




import Site from "@/models/site";
import { LayoutModule } from "@/store/layout";
import { Component, Vue } from "vue-property-decorator";
import SitesAPI from "@/services/sites";
import SiteForm from "./Components/SiteForm.vue";

@Component({
  components: { SiteForm },
})
export default class NewSite extends Vue {
  async save(site: Site): Promise<void> {
    LayoutModule.showLoader();
    try {
      await SitesAPI.newSite(site);
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "sites" });
  }
}
